import React from 'react'

export const PresbiteryHistory = () => {
  return (
    <div className="container mt-5 mb-5">
        {/* Encabezado Principal */}
        <div className="text-center mb-5">
            <h1 className="display-4 fw-bold text-primary">Presbiterio de Guanajuato</h1>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                    <li className="breadcrumb-item active">ICIAR - Iglesia Cristiana Interdenominacional A.R.</li>
                </ol>
            </nav>
            <div className="col-lg-8 mx-auto">
                <p className="lead text-secondary">
                    Nuestra denominación tiene sus raíces en la Ciudad de México, en la colonia Portales, 
                    comenzando en el año 1926 bajo el pastoreado del Hno. Josué Mejía.
                </p>
            </div>
        </div>

        <div className="row g-5">
            {/* Columna Izquierda: Inicio y Expansión */}
            <div className="col-12 col-lg-6">
                <div className="sticky-top" style={{ top: '2rem' }}>
                    <h2 className="h3 border-bottom pb-2 mb-4 text-dark">Orígenes y Primeros Pasos</h2>
                    <p className="text-muted small">Relato por: <strong>Hna. Esther Castro</strong></p>
                    
                    <div className="lh-lg">
                        <p>
                            Mis recuerdos son a partir de los años <strong>44 al 45</strong>. En ese tiempo, un grupo pequeño nos congregábamos en hogares: 
                            los hermanos Centeno, la familia Ramírez-Olmos y el hogar del hermano Daniel Hernández, quien pastoreaba la pequeña congregación.
                        </p>
                        <p>
                            El Evangelio llegó a Guanajuato por parte de la Inter en <strong>1939</strong>, a través del hermano <strong>Isabel Bravo</strong>, 
                            primer presidente del entonces llamado <em>Consistorio de Occidente</em>.
                        </p>
                        
                        <div className="card bg-light border-0 my-4 shadow-sm">
                            <div className="card-body">
                                <h5 className="card-title text-primary">El Primer Templo (1945)</h5>
                                <p className="card-text">
                                    Compramos una casa antigua y acondicionamos un salón muy humilde. Allí, en el año 46, contraje nupcias con el hermano Marcos Casillas.
                                </p>
                            </div>
                        </div>

                        <p>
                            Con la llegada de la hermana <strong>Natalia Medina Estrada</strong>, la obra tomó un vigor espiritual nuevo. 
                            Se organizaron institutos bíblicos en Irapuato y La Noria, formando a los obreros que llevarían la palabra a los campos.
                        </p>

                        <blockquote className="blockquote my-4 py-3 ps-4 border-start border-4 border-primary bg-white shadow-sm">
                            <p className="mb-0 italic fw-bold text-dark">"¡Amo a María, pero adoro a Cristo!"</p>
                            <footer className="blockquote-footer mt-1">Palabras del Hno. Josué Mejía en Noria de Barajas (1945)</footer>
                        </blockquote>
                    </div>
                </div>
            </div>
            
            {/* Columna Derecha: Crecimiento y Persecución */}
            <div className="col-12 col-lg-6">
                <h2 className="h3 border-bottom pb-2 mb-4 text-dark">Crecimiento y Testimonios</h2>
                
                <div className="lh-lg">
                    <p>
                        Por el Consistorio de Occidente pasaron muchos siervos que dejaron su huella: Daniel Guerrero, Eduardo Cedillo, 
                        Melquiades Vera y Liborio Blanco, quien nos sacó adelante en condiciones críticas durante 15 años.
                    </p>
                    <p>
                        Hoy, bajo la dirección del hermano <strong>Gonzalo González</strong>, vemos cumplida la promesa de Dios. 
                        Lo que comenzó con 4 misiones, actualmente son <strong>50 misiones</strong> activas.
                    </p>

                    <div className="alert alert-warning mt-5 shadow-sm border-0">
                        <h4 className="alert-heading h5 fw-bold">Relatos de Persecución (1948)</h4>
                        <hr />
                        <p className="mb-0">
                            En Cuéramaro, fanáticos dirigidos por un sacerdote quemaron nuestras Biblias y bancas. 
                            Sin embargo, Dios cegó los ojos de los atacantes y los hermanos no sufrieron daño físico alguno.
                        </p>
                    </div>

                    <p className="mt-4">
                        También recordamos a la hermana Margarita Rodríguez en San Pedro de los Naranjos y a la hermana Natalia Medina 
                        en El Paso de Cobos; ambas amenazadas de muerte, pero sostenidas por el poder de Dios.
                    </p>

                    <div className="p-4 bg-dark text-white rounded-3 mt-5 shadow">
                        <h3 className="h5 mb-3 text-center">Conclusión</h3>
                        <p className="small fst-italic text-center">
                            "¿Quién nos separará del amor de Cristo? ¿Tribulación, o angustia, o persecución, o hambre, o desnudez, o peligro, o espada?" (Rom. 8:35).
                        </p>
                        <p className="text-end mt-4 mb-0 fw-bold border-top pt-3">
                            ¡A su nombre toda la gloria!
                        </p>
                    </div>
                </div>
            </div>
        </div>

        {/* Footer del Relato */}
        <div className="row mt-5">
            <div className="col-12 text-center text-muted border-top pt-4">
                <p>Presbiterio de Guanajuato - Documento Histórico</p>
            </div>
        </div>
    </div>
  )
}